import { api, type ApiEnvelope } from '../../services/api';
import type { AdminAuthUser } from '../../store/adminAuthStore';

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export const adminAuthService = {
  async login(payload: AdminLoginPayload) {
    const { data } = await api.post<ApiEnvelope<{ admin: AdminAuthUser }>>('/auth/admin/login', payload);
    return data.data.admin;
  },
  async logout() {
    await api.post('/auth/admin/logout');
  },
  async me() {
    const { data } = await api.get<ApiEnvelope<{ admin: AdminAuthUser }>>('/auth/admin/me');
    return data.data.admin;
  },
};
